module.exports = __webpack_public_path__ + "img/empty.de9611a.gif";